import { PROMPT_ROTATE } from "../components/Viewer";

// App Actions
const UPDATE_PROMPT_MODE = "UPDATE_PROMPT_MODE";
const UPDATE_PROMPT_SHOWCASE = "UPDATE_PROMPT_SHOWCASE";
const UPDATE_AR_MODE = "UPDATE_AR_MODE";

// Initial state
const initialState = {
    prompt_mode: PROMPT_ROTATE,
    prompt_showcase: true,
    ar_mode: "",
};

// Reducer
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PROMPT_MODE:
        case UPDATE_PROMPT_SHOWCASE:
        case UPDATE_AR_MODE:
            return {
                ...state,
                [action.parameter]: action.value,
            };
        default:
            return state;
    }
};

// Getters
export const getPromptMode = state => state.app.prompt_mode;
export const getPromptShowcase = state => state.app.prompt_showcase;
export const getARMode = state => state.app.ar_mode;

// Setters
export const setPromptMode = mode => {
    return {
        type: UPDATE_PROMPT_MODE,
        parameter: "prompt_mode",
        value: mode,
    };
};
export const setPromptShowcase = showcase => {
    return {
        type: UPDATE_PROMPT_SHOWCASE,
        parameter: "prompt_showcase",
        value: showcase,
    };
};
export const setARMode = mode => {
    return {
        type: UPDATE_AR_MODE,
        parameter: "ar_mode",
        value: mode,
    };
};

export default reducer;